module.exports = __webpack_public_path__ + "500f67a91e7eef91b32b10bcfa327b95.svg";